<template>
  <iframe src="https://cswebcl.slamdunknoone.com/" style="width: 100%;height: 98%;" />
</template>
<script>
</script>
